export type CaptchaProtectedPayload<T extends object> = T & {
  captchaToken: string;
};

export function buildCaptchaProtectedPayload<T extends object>(
  formValues: T,
  captchaToken: string | null,
): CaptchaProtectedPayload<T> {
  const normalizedToken = captchaToken?.trim();
  if (!normalizedToken) throw new Error('Captcha verification failed. Please try again.');

  return {
    ...formValues,
    captchaToken: normalizedToken,
  };
}
